import React from 'react';
import cn from 'classname';
import './index.less';

function PayoutIsUrgentIcon({ active, onClick }) {
	const className = active === undefined ? 'default' : (active ? 'active' : 'inactive');
	return (
		<div
			className={cn('payout-table--is-urgent-icon', className, onClick && 'pointer')}
			onClick={onClick}
		/>
	);
}

export default PayoutIsUrgentIcon;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payouts/components/table/components/components/payout-is-urgent-icon/index.js